<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="section" style="height: 100%;padding: 0 5px;display: flex;flex-direction: row;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :row-data="rowData"
          :show-side-bar="false"
          :class="isPreview || isEdit ? 'not-click' : ''"
          style="flex: 0 0 auto;width: 200px;margin: 5px 0;"
        />
        <div style="flex: 0 0 auto;width: 2px;margin: 0 5px;background: #DCDFE6;" />
        <div class="main-content" style="flex-grow: 1;height: auto;margin: 5px 0;">
          <div class="operations">
            <div class="triggers">
              <div v-if="!!moduleRow" style="padding-left: 15px;">
                <template>
                  <span style="margin-right: 8px;">{{ $t('SeaExport.opOffice') }}</span>
                  <el-select v-model="branchId" filterable>
                    <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="item.officeId" />
                  </el-select>
                </template>
                <el-button v-if="moduleRow.enableInstruction" type="primary" @click="editOpInstructionDialog">{{ $t('SystemMaintenance.SetOpInstruction') }}</el-button>
                <el-button v-if="moduleRow.module === SEA_BOOKING_MODULE" key="valueSync" type="primary" @click="showValueSyncSetDialog">{{ $t('SystemMaintenance.SetFieldValueSynchronization') }}</el-button>
              </div>
              <div v-if="!!validateRow" style="padding-left: 5px;margin-bottom: 5px;">
                <template v-if="isPreview && !validateRow.disableCustomPage">
                  <el-button key="back" type="primary" @click="isPreview=false;previewConfig=null">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
                </template>
                <template v-if="!isPreview && !validateRow.disableCustomPage">
                  <template v-if="readonly">
                    <el-button key="edit" :disabled="branchId!==1&&useHqSet" type="primary" @click="onEdit">{{ $t('Message.Edit') }}</el-button>
                    <el-button key="readPreview" type="primary" @click="onPreview">{{ $t('CargoMsg.Cargo_Preview') }}</el-button>
                    <span key="opOffice" style="margin: 0px 8px;">{{ $t('SeaExport.opOffice') }}</span>
                  </template>
                  <template v-else>
                    <el-button key="save" type="success" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                    <el-button key="cancel" type="success" @click="onCancel">{{ $t('Message.Cancel') }}</el-button>
                    <el-button key="editPreview" type="primary" @click="onPreview">{{ $t('CargoMsg.Cargo_Preview') }}</el-button>
                    <el-button key="reset" :disabled="branchId !== 1 && useHqSet" type="warning" @click="onReset">{{ $t('Message.Reset') }}</el-button>
                    <span key="branchCMP" style="margin: 0px 8px;">{{ $t('CargoMsg.Cargo_BranchCMP') }}</span>
                  </template>
                  <el-select v-model="branchId" :disabled="isEdit" filterable @change="loadData()">
                    <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="item.officeId" />
                  </el-select>
                  <span style="margin: 0 5px 0 10px;">{{ $t('CargoMsg.Cargo_GeneralSettings') }}</span>
                  <el-checkbox :value="useHqSet" :disabled="isEdit" style="margin-right: 10px" @input="onUseHqSetInput(!useHqSet)" />
                  <span v-if="branchId!==1">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.HQSettingNotEditAlias') }}
                  </span>
                  <!-- <span v-if="!isEdit && showAddedTip" style="color: red;">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.CurrentPageNewFieldTip') }}
                  </span> -->
                  <template v-if="readonly && fieldPermissionCanPageTypes.includes(validateRow.pageType) && enableUICustomFieldPermissioin">
                    <el-button type="primary" @click="onFieldPermissionSet">{{ $t('SystemMaintenance.FieldPermissionSettings') }}</el-button>
                  </template>
                </template>
                <template v-if="!isPreview && (validateRow.enableInstruction || validateRow.enableBillPayment)">
                  <template v-if="validateRow.disableCustomPage">
                    <span key="instructionOpOffice" style="margin: 0px 8px;">{{ $t('SeaExport.opOffice') }}</span>
                    <el-select v-model="branchId" filterable @change="loadData()">
                      <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="item.officeId" />
                    </el-select>
                  </template>
                </template>
                <template v-if="!isPreview && pageSetBtnVisible">
                  <el-button key="pageSet" :disabled="validateRow.disableCustomPage ? false : readonly" type="primary" @click="showPageSetDialog">{{ $t('SystemMaintenance.TabSettings') }}</el-button>
                </template>
                <template v-if="!isPreview && validateRow.enableInstruction">
                  <el-button key="setOpInstruction" type="primary" @click="editOpInstructionDialog">{{ $t('SystemMaintenance.SetOpInstruction') }}</el-button>
                </template>
                <template v-if="!isPreview && validateRow.billPaymentSetting">
                  <el-button key="paymentRequestSettings" type="primary" @click="billPaymentSettingsHandler">{{ $t('CargoMsg.Cargo_PaymentRequestSettings') }}</el-button>
                </template>
                <template v-if="showBillPaymentRuleSettings">
                  <el-button key="billPaymentRuleSettings" type="primary" :disabled="!billPaymentSetting.supervisorApproval" @click="billPaymentRuleSettingsHandler">{{ $t('CargoMsg.Cargo_RuleSettings') }}</el-button>
                </template>
                <template v-if="!isPreview && !validateRow.disableCustomPage && isEdit">
                  <span v-if="validateRow.pageType === REMOTE_SEA_BOOKING_BASIC">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.TheAsThoseForConfiguration') }}
                  </span>
                  <span v-if="validateRow.pageType === REMOTE_AIR_BOOKING_BASIC">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.TheAsTheAirConfiguration') }}
                  </span>
                  <span v-if="validateRow.pageType === REMOTE_RE_BOOKING_BASIC || validateRow.pageType === REMOTE_RI_BOOKING_BASIC">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.TheThoseInTheConfiguration') }}
                  </span>
                  <span v-if="validateRow.pageType === SEA_VERIFY_BOOKING_BASIC || validateRow.pageType === SEA_VERIFY_BOOKING_VESSEL">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.TheAsTheOceanConfiguration') }}
                  </span>
                  <span v-if="validateRow.pageType === AIR_VERIFY_BOOKING_BASIC">
                    <i class="el-icon-warning" style="color: #e6a23c;font-size: 14px;" />
                    {{ $t('SystemMaintenance.TheOrderInTheConfiguration') }}
                  </span>
                </template>
              </div>
            </div>
          </div>
          <template v-if="validateRow">
            <sea-booking-basic
              v-if="validateRow.pageType === SEA_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-vessel
              v-if="validateRow.pageType === SEA_BOOKING_VESSEL || validateRow.pageType === SEA_VERIFY_BOOKING_VESSEL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
              :page-type="validateRow.pageType"
            />
            <air-booking-basic
              v-if="validateRow.pageType === AIR_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <air-booking-vessel
              v-if="validateRow.pageType === AIR_BOOKING_VESSEL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <remote-sea-booking-basic
              v-if="validateRow.pageType === REMOTE_SEA_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <remote-air-booking-basic
              v-if="validateRow.pageType === REMOTE_AIR_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <remote-railway-booking-basic
              v-if="validateRow.pageType === REMOTE_RE_BOOKING_BASIC || validateRow.pageType === REMOTE_RI_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-verify-booking-basic
              v-if="validateRow.pageType === SEA_VERIFY_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <railway-booking-basic
              v-if="validateRow.pageType === RAILWAY_BOOKING_RE_BASIC || validateRow.pageType === RAILWAY_BOOKING_RI_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <air-import-booking-basic
              v-if="validateRow.pageType === AI_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-import-booking-basic
              v-if="validateRow.pageType === SI_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-import-arrival-info
              v-if="validateRow.pageType === SI_BOOKING_ARRIVAL_INFO"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-mbl
              v-if="validateRow.pageType === SEA_BOOKING_MBL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-mbl2
              v-if="validateRow.pageType === SEA_BOOKING_MBL_SPLIT || validateRow.pageType === SEA_BOOKING_MBL_MERGE"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-hbl
              v-if="validateRow.pageType === SEA_BOOKING_HBL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-hbl2
              v-if="validateRow.pageType === SEA_BOOKING_HBL_SPLIT || validateRow.pageType === SEA_BOOKING_HBL_MERGE"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-virtual-hbl
              v-if="validateRow.pageType === SEA_BOOKING_VIRTUAL_HBL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-charge
              v-if="validateRow.pageType === SEA_BOOKING_CHARGE_RECEIVABLE || validateRow.pageType === SEA_BOOKING_CHARGE_PAYABLE"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-special-goods
              v-if="validateRow.pageType === SEA_BOOKING_SPECIAL_GOODS"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <customs-info
              v-if="validateRow.pageType === SEA_BOOKING_CUSTOMS"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-trucking
              v-if="validateRow.pageType === SEA_BOOKING_TRUCKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-discharging-trucking
              v-if="validateRow.pageType === SEA_BOOKING_DISCHARGING_TRUCKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <ic-booking-basic
              v-if="validateRow.pageType === INTEGRATED_IC_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-container
              v-if="validateRow.pageType === SEA_BOOKING_CONTAINER_INFO"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <cl-booking-basic
              v-if="validateRow.pageType === INTEGRATED_CL_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <tt-booking-basic
              v-if="validateRow.pageType === INTEGRATED_TT_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-internal-bill
              v-if="validateRow.pageType === SEA_BOOKING_DOMESTIC_BILLING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-oversea-bill
              v-if="validateRow.pageType === SEA_BOOKING_OVERSEA_BILL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <air-verify-booking-basic
              v-if="validateRow.pageType === AIR_VERIFY_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <grid-tab-script
              v-if="gridTabScriptPageTypes.includes(validateRow.pageType)"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
              :hide-required="gridTabScriptHideRequire.includes(validateRow.pageType)"
              :hide-alias="gridTabScriptHideAlias.includes(validateRow.pageType)"
              :hide-setting="gridTabScriptHideSetting.includes(validateRow.pageType)"
            />
            <company-basic
              v-if="validateRow.pageType === COMPANY_NATIVE_CUSTOMER_VENDOR_RATING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <grid-tab
              v-if="gridTabPageTypes.includes(validateRow.pageType)"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
              :can-set-alias-function="canSetAliasFunction"
            >
              <se-tab-lcl-container slot="preview" :context="seBookingWorkspaceContext" action="look" :preview-config="previewConfig" :enable-ui-custom="true" />
            </grid-tab>
          </template>
        </div>
      </div>
    </div>
    <!-- 保存确认弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="saveConfirmDialog.visible"
      :title="branchId === 1 ? $t('SystemMaintenance.HQSavePrompt') : $t('SystemMaintenance.BranchSavePrompt')"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px">
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope') + ':'">
          <el-radio v-model="saveConfirmDialog.applyRange" :label="0" style="white-space: normal;">
            {{ branchId === 1 ? $t('SystemMaintenance.OnlyDisplayMandatoryRule') : $t('SystemMaintenance.OfficeOnlyDisplayMandatoryRule') }}
          </el-radio>
        </el-form-item>
        <el-form-item label=" ">
          <el-radio v-model="saveConfirmDialog.applyRange" :label="1" style="white-space: normal;">
            {{ branchId === 1 ? $t('SystemMaintenance.DisplayMandatorySort') : $t('SystemMaintenance.OfficeDisplayMandatorySort') }}
          </el-radio>
        </el-form-item>
        <el-form-item v-if="saveConfirmDialog.applyRange===1" label=" " style="margin-top: -10px;">
          <span>
            <i class="el-icon-warning" style="color: #e6a23c;" />
            {{ branchId === 1 ? $t('SystemMaintenance.AdjustOrderConfig') : $t('SystemMaintenance.OfficeAdjustOrderConfig') }}
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="doSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="saveConfirmDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 操作指令设置弹窗 -->
    <instruction-set-dialog :visible.sync="instructionSetDialog.visible" :module="instructionSetDialog.module" :page-type="instructionSetDialog.pageType" :branch-id="branchId" :lob="instructionSetDialog.lob" :tenant-instructions="instructionSetDialog.availableTenantInstructions" :specific-business-rules="specificBusinessRules" :use-hq-set="useHqSet" :readonly="false" />
    <!-- 字段权限设置弹窗 -->
    <field-permission-set-dialog :visible.sync="fieldPermissionSetDialog.visible" :page-type="fieldPermissionSetDialog.pageType" :page-name="fieldPermissionSetDialog.pageName" :lob="fieldPermissionSetDialog.lob" :branch-id="branchId" :blocks="blocks" @updateCallback="onFieldPermissionSetUpdateCallback" />
    <!-- 页面设置弹窗 -->
    <page-set-dialog :visible.sync="pageSetDialog.visible" :page-type="pageSetDialog.pageType" />
    <!-- 值同步设置弹窗 -->
    <value-sync-set-dialog :visible.sync="valueSyncSetDialog.visible" :module="valueSyncSetDialog.module" :branch-id="branchId" />
    <!-- 付款申请设置弹窗 -->
    <bill-payment-setting-dialog :visible.sync="billPaymentSetDialog.visible" :page-type="billPaymentSetDialog.pageType" :branch-id="branchId" :lob="billPaymentSetDialog.lob" :readonly="false" />
    <!-- 付款申请规则设置弹窗 -->
    <bill-payment-rule-setting-dialog :visible.sync="billPaymentRuleSetDialog.visible" :page-type="billPaymentRuleSetDialog.pageType" :branch-id="branchId" :lob="billPaymentRuleSetDialog.lob" :specific-business-rules="specificBusinessRules" :readonly="false" />

  </div>
</template>

<script>
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { BookingWorkspaceContext as SeBookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import seaBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingBasic'
import seaBookingVessel from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingVessel'
import airBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/airBookingBasic'
import airBookingVessel from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/airBookingVessel'
import remoteSeaBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteSeaBookingBasic'
import remoteAirBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteAirBookingBasic'
import remoteRailwayBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteRailwayBookingBasic'
import seaVerifyBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaVerifyBookingBasic'
import railwayBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/railwayBookingBasic'
import airImportBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/airImportBookingBasic'
import seaImportBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaImportBookingBasic'
import seaImportArrivalInfo from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaImportArrivalInfo'
import seaBookingMbl from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingMbl'
import seaBookingMbl2 from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingMbl2'
import InstructionSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/InstructionSetDialog'
import FieldPermissionSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/FieldPermissionSetDialog'
import seaBookingHbl from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingHbl'
import seaBookingHbl2 from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingHbl2'
import seaBookingVirtualHbl from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingVirtualHbl'
import seaBookingCharge from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingCharge'
import seaBookingSpecialGoods from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingSpecialGoods'
import customsInfo from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/customsInfo'
import seaBookingTrucking from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingTrucking'
import seaBookingDischargingTrucking from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingDischargingTrucking'
import PageSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/PageSetDialog'
import { getBranchBillPaymentSetting, getBranchElementBlockList, saveUICustom } from '@/api/sysManage/uiCustom'
import lodash from 'lodash'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { queryAllTenantInstruction, querySpecificBusinessRuleByTenant } from '@/api/sysManage/baseConfig/instruction'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import IcBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/icBookingBasic'
import ClBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/clBookingBasic'
import TtBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ttBookingBasic'
import BillPaymentSettingDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/billPaymentSettingDialog.vue'
import BillPaymentRuleSettingDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/billPaymentRuleSettingDialog.vue'
import ValueSyncSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ValueSyncSetDialog'
import seaBookingContainer from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingContainer'
import seaBookingInternalBill from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingInternalBill'
import seaBookingOverseaBill from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingOverseaBill'
import AirVerifyBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/airVerifyBookingBasic.vue'
import gridTabScript from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/gridTabScript'
import gridTab from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/gridTab'
import seTabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'
import CompanyBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/companyBasic.vue'

export default {
  name: 'PageUICustom',
  components: { CompanyBasic, AirVerifyBookingBasic, BillPaymentSettingDialog, BillPaymentRuleSettingDialog, TtBookingBasic, ClBookingBasic, IcBookingBasic, seaBookingBasic, seaBookingVessel, airBookingBasic, airBookingVessel, remoteSeaBookingBasic, remoteAirBookingBasic, remoteRailwayBookingBasic, seaVerifyBookingBasic, railwayBookingBasic, airImportBookingBasic, seaImportBookingBasic, seaImportArrivalInfo, seaBookingMbl, seaBookingMbl2, InstructionSetDialog, FieldPermissionSetDialog, seaBookingHbl, seaBookingHbl2, seaBookingVirtualHbl, seaBookingCharge, seaBookingSpecialGoods, customsInfo, seaBookingTrucking, seaBookingDischargingTrucking, PageSetDialog, ValueSyncSetDialog, seaBookingContainer, seaBookingInternalBill, seaBookingOverseaBill, gridTabScript, gridTab, seTabLclContainer },
  data() {
    return {
      SEA_BOOKING_MODULE: UICustomConstants.SEA_BOOKING_MODULE,
      SEA_BOOKING_BASIC: UICustomConstants.SEA_BOOKING_BASIC,
      SEA_BOOKING_VESSEL: UICustomConstants.SEA_BOOKING_VESSEL,
      AIR_BOOKING_BASIC: UICustomConstants.AIR_BOOKING_BASIC,
      AIR_BOOKING_VESSEL: UICustomConstants.AIR_BOOKING_VESSEL,
      REMOTE_SEA_BOOKING_BASIC: UICustomConstants.REMOTE_SEA_BOOKING_BASIC,
      REMOTE_AIR_BOOKING_BASIC: UICustomConstants.REMOTE_AIR_BOOKING_BASIC,
      REMOTE_RE_BOOKING_BASIC: UICustomConstants.REMOTE_RE_BOOKING_BASIC,
      REMOTE_RI_BOOKING_BASIC: UICustomConstants.REMOTE_RI_BOOKING_BASIC,
      SEA_VERIFY_BOOKING_BASIC: UICustomConstants.SEA_VERIFY_BOOKING_BASIC,
      SEA_VERIFY_BOOKING_VESSEL: UICustomConstants.SEA_VERIFY_BOOKING_VESSEL,
      RAILWAY_BOOKING_RE_BASIC: UICustomConstants.RAILWAY_BOOKING_RE_BASIC,
      RAILWAY_BOOKING_RI_BASIC: UICustomConstants.RAILWAY_BOOKING_RI_BASIC,
      AI_BOOKING_BASIC: UICustomConstants.AI_BOOKING_BASIC,
      SI_BOOKING_BASIC: UICustomConstants.SI_BOOKING_BASIC,
      SI_BOOKING_ARRIVAL_INFO: UICustomConstants.SI_BOOKING_ARRIVAL_INFO,
      SEA_BOOKING_MBL: UICustomConstants.SEA_BOOKING_MBL,
      SEA_BOOKING_MBL_SPLIT: UICustomConstants.SEA_BOOKING_MBL_SPLIT,
      SEA_BOOKING_MBL_MERGE: UICustomConstants.SEA_BOOKING_MBL_MERGE,
      SEA_BOOKING_HBL: UICustomConstants.SEA_BOOKING_HBL,
      SEA_BOOKING_HBL_SPLIT: UICustomConstants.SEA_BOOKING_HBL_SPLIT,
      SEA_BOOKING_HBL_MERGE: UICustomConstants.SEA_BOOKING_HBL_MERGE,
      SEA_BOOKING_VIRTUAL_HBL: UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
      SEA_BOOKING_CHARGE_RECEIVABLE: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE,
      SEA_BOOKING_CHARGE_PAYABLE: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE,
      SEA_BOOKING_SPECIAL_GOODS: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS,
      SEA_BOOKING_CUSTOMS: UICustomConstants.SEA_BOOKING_CUSTOMS,
      SEA_BOOKING_TRUCKING: UICustomConstants.SEA_BOOKING_TRUCKING,
      SEA_BOOKING_DISCHARGING_TRUCKING: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING,
      INTEGRATED_IC_BOOKING: UICustomConstants.INTEGRATED_IC_BOOKING,
      AIR_VERIFY_BOOKING_BASIC: UICustomConstants.AIR_VERIFY_BOOKING_BASIC,
      INTEGRATED_CL_BOOKING: UICustomConstants.INTEGRATED_CL_BOOKING,
      INTEGRATED_TT_BOOKING: UICustomConstants.INTEGRATED_TT_BOOKING,
      SEA_BOOKING_CONTAINER_INFO: UICustomConstants.SEA_BOOKING_CONTAINER_INFO,
      SEA_BOOKING_DOMESTIC_BILLING: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING,
      SEA_BOOKING_OVERSEA_BILL: UICustomConstants.SEA_BOOKING_OVERSEA_BILL,
      COMPANY_NATIVE_CUSTOMER_VENDOR_RATING: UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: false,
        treeData: true,
        groupDefaultExpanded: 4,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SystemMaintenance.Name'),
          field: 'name',
          width: 187,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return params.value
            }
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: event => {
          if (event.data.module) {
            this.moduleRow = event.data
          } else {
            this.moduleRow = null
          }
          if (event.data.dataType === 2) {
            this.validateRow = event.data
          } else {
            this.validateRow = null
          }
          this.loadData()
        }
      },
      rowData: [
        { name: this.$t('SystemMaintenance.SalesModule'), path: 'sales', dataType: 1 },
        { name: this.$t('SystemMaintenance.SalesInquiry'), path: 'sales,salesInquiry', dataType: 1 },
        { name: this.$t('Sales.SalesInquiryListPage'), path: 'sales,salesInquiry,list', dataType: 2, pageType: UICustomConstants.SALES_INQUIRY_LIST },
        { name: this.$t('CargoMsg.Cargo_SeaBooking'), path: 'sales,salesInquiry,SE', dataType: 1 },
        { name: this.$t('SeaExport.BasicTab'), path: 'sales,salesInquiry,SE,basic', dataType: 2, pageType: UICustomConstants.SALES_INQUIRY_SE_BASIC, disableCustomPage: true, enableInstruction: true, lob: 'SE', instructionType: 'DATA_FILL' },
        { name: this.$t('route.remoteBooking'), path: 'sales,remoteBooking', dataType: 1 },
        { name: this.$t('Sales.RemoteBookingListPage'), path: 'sales,remoteBooking,list', dataType: 2, pageType: UICustomConstants.REMOTE_BOOKING_LIST },
        { name: this.$t('CargoMsg.Cargo_SeaBooking'), path: 'sales,remoteBooking,bookingNew', dataType: 1 },
        { name: this.$t('SystemMaintenance.EntrustPageTab'), path: 'sales,remoteBooking,bookingNew,basic', dataType: 2, pageType: UICustomConstants.REMOTE_SEA_BOOKING_BASIC },
        { name: this.$t('route.airExportBooking'), path: 'sales,remoteBooking,aeBooking', dataType: 1 },
        { name: this.$t('SystemMaintenance.EntrustPageTab'), path: 'sales,remoteBooking,aeBooking,basic', dataType: 2, pageType: UICustomConstants.REMOTE_AIR_BOOKING_BASIC },
        { name: this.$t('CargoMsg.Cargo_RailwayBooking'), path: 'sales,remoteBooking,railwayBooking', dataType: 1 },
        { name: this.$t('SystemMaintenance.ImportEntrustPageTab'), path: 'sales,remoteBooking,railwayBooking,riBasic', dataType: 2, pageType: UICustomConstants.REMOTE_RI_BOOKING_BASIC },
        { name: this.$t('SystemMaintenance.ExportEntrustPageTab'), path: 'sales,remoteBooking,railwayBooking,reBasic', dataType: 2, pageType: UICustomConstants.REMOTE_RE_BOOKING_BASIC },
        { name: this.$t('CargoMsg.Cargo_OceanExport'), path: 'SE', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_BookingPreAudit'), path: 'SE,bookingVerify', dataType: 1 },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'SE,bookingVerify,basic', dataType: 2, pageType: UICustomConstants.SEA_VERIFY_BOOKING_BASIC },
        { name: this.$t('Message.BookingLabel'), path: 'SE,bookingVerify,vesselEq', dataType: 2, pageType: UICustomConstants.SEA_VERIFY_BOOKING_VESSEL },
        {
          name: this.$t('CargoMsg.Cargo_SeaBooking'),
          path: 'SE,bookingNew',
          dataType: 1,
          module: UICustomConstants.SEA_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'SE',
          instructionFilterCallback: (p) => {
            if (p.instructionType === 'DATA_FILL' && p.instructionRuleJson?.batchBusinessProcessing) {
              return true
            }
            if (p.platformInstructionCode === 'sameTenantCrossDelegation') {
              return true
            }
            return false
          }
        },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'SE,bookingNew,basic', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_BASIC, enableInstruction: true, lob: 'SE', instructionType: 'DATA_FILL' },
        { name: this.$t('Message.BookingLabel'), path: 'SE,bookingNew,vesselEq', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_VESSEL },
        { name: 'MBL' + this.$t('SeaExport.tab'), path: 'SE,bookingNew,mbl', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_MBL },
        { name: 'MBL' + this.$t('CargoMsg.Cargo_SplitBL'), path: 'SE,bookingNew,mblSplit', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_MBL_SPLIT },
        { name: 'MBL' + this.$t('SeaImport.MergeOrder'), path: 'SE,bookingNew,mblMerge', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_MBL_MERGE },
        { name: 'HBL' + this.$t('SeaExport.tab'), path: 'SE,bookingNew,hbl', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_HBL, enableInstruction: true, lob: 'SE' },
        { name: 'HBL' + this.$t('CargoMsg.Cargo_SplitBL'), path: 'SE,bookingNew,hblSplit', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_HBL_SPLIT },
        { name: 'HBL' + this.$t('SeaImport.MergeOrder'), path: 'SE,bookingNew,hblMerge', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_HBL_MERGE },
        { name: this.$t('SeaExport.FormalHbl'), path: 'SE,bookingNew,virtualHbl', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_VIRTUAL_HBL },
        { name: this.$t('SystemMaintenance.ShippingInformationNonMainInvoice'), path: 'SE,bookingNew,containerInfo', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO },
        { name: this.$t('SystemMaintenance.ShippingInformationMasterBill'), path: 'SE,bookingNew,containerInfoMaster', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER },
        { name: this.$t('queryJob.FeeReceivable'), path: 'SE,bookingNew,ar', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE },
        { name: this.$t('queryJob.CostsPayable'), path: 'SE,bookingNew,ap', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE },
        { name: this.$t('SeaExport.Trucking'), path: 'SE,bookingNew,trucking', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_TRUCKING },
        { name: this.$t('SeaExport.DispatchVehiclesAtDestination'), path: 'SE,bookingNew,dischargingTrucking', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING },
        { name: this.$t('CargoMsg.Cargo_CustomsDeclaration'), path: 'SE,bookingNew,customs', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CUSTOMS },
        {
          name: this.$t('SeaExport.InternalBillInfo'),
          path: 'SE,bookingNew,internalBillInfo',
          dataType: 2,
          pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING,
          enableInstruction: true,
          lob: 'SE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'createDomesticBills' || p.platformInstructionCode === 'internalBillEdit'
        },
        {
          name: this.$t('SeaExport.OverseaBillInfo'),
          path: 'SE,bookingNew,overseaBillInfo',
          dataType: 2,
          pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL,
          enableInstruction: true,
          lob: 'SE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'overseaBillEdit'
        },
        { name: this.$t('SpecialGoods.label'), path: 'SE,bookingNew,specialGoods', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS },
        { name: this.$t('SystemMaintenance.FileHistoryTab'), path: 'SE,bookingNew,fileHistoy', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_FILE_HISTORY, disableCustomPage: true, enableInstruction: true, lob: 'SE' },
        { name: this.$t('CargoMsg.Cargo_OceanImport'), path: 'SI', dataType: 1 },
        {
          name: this.$t('route.seaImportBooking'),
          path: 'SI,booking',
          dataType: 1,
          module: UICustomConstants.SI_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'SI',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        { name: this.$t('SeaExport.ImportOperation'), path: 'SI,booking,basic', dataType: 2, pageType: UICustomConstants.SI_BOOKING_BASIC },
        { name: this.$t('SeaExport.ArrivalInformation'), path: 'SI,booking,arrivalInfo', dataType: 2, pageType: UICustomConstants.SI_BOOKING_ARRIVAL_INFO },
        { name: this.$t('CargoMsg.Cargo_AirExport'), path: 'AE', dataType: 1 },
        { name: this.$t('route.preOrder'), path: 'AE,bookingVerify', dataType: 1 },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'AE,bookingVerify,basic', dataType: 2, pageType: UICustomConstants.AIR_VERIFY_BOOKING_BASIC },
        {
          name: this.$t('route.airExportBooking'),
          path: 'AE,aeBooking',
          dataType: 1,
          module: UICustomConstants.AIR_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'AE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'AE,aeBooking,basic', dataType: 2, pageType: UICustomConstants.AIR_BOOKING_BASIC },
        { name: this.$t('Message.BookingLabel'), path: 'AE,aeBooking,vesselEq', dataType: 2, pageType: UICustomConstants.AIR_BOOKING_VESSEL },
        { name: this.$t('queryJob.FeeReceivable'), path: 'AE,aeBooking,ar', dataType: 2, pageType: UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE },
        { name: this.$t('queryJob.CostsPayable'), path: 'AE,aeBooking,ap', dataType: 2, pageType: UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE },
        { name: this.$t('CargoMsg.Cargo_AirImport'), path: 'AI', dataType: 1 },
        {
          name: this.$t('SeaExport.AirOperation'),
          path: 'AI,aiBooking',
          dataType: 1,
          module: UICustomConstants.AI_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'AI',
          instructionFilterCallback: (p) => false
        },
        { name: this.$t('SystemMaintenance.AirOperationTAB'), path: 'AI,aiBooking,basic', dataType: 2, pageType: UICustomConstants.AI_BOOKING_BASIC },
        { name: this.$t('CargoMsg.Cargo_RailwayExport'), path: 'RE', dataType: 1 },
        {
          name: this.$t('CargoMsg.Cargo_RailwayOperate'),
          path: 'RE,reBooking',
          dataType: 1,
          module: UICustomConstants.RAILWAY_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'RE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'RE,reBooking,basic', dataType: 2, pageType: UICustomConstants.RAILWAY_BOOKING_RE_BASIC },
        { name: this.$t('CargoMsg.Cargo_RailwayImport'), path: 'RI', dataType: 1 },
        {
          name: this.$t('CargoMsg.Cargo_RailwayOperate'),
          path: 'RI,reBooking',
          dataType: 1,
          module: UICustomConstants.RAILWAY_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'RI',
          instructionFilterCallback: (p) => false
        },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'RI,reBooking,basic', dataType: 2, pageType: UICustomConstants.RAILWAY_BOOKING_RI_BASIC },
        { name: this.$t('CargoMsg.Cargo_IntegratedJob'), path: 'IE', dataType: 1 },
        {
          name: this.$t('CargoMsg.Cargo_IC'),
          path: 'IE,icBooking',
          dataType: 1,
          module: UICustomConstants.IC_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'IE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        { name: this.$t('CargoMsg.Cargo_IC_Basic'), path: 'IE,icBooking,basic', dataType: 2, pageType: UICustomConstants.INTEGRATED_IC_BOOKING },
        { name: this.$t('CargoMsg.Cargo_Settlement'), path: 'FS', dataType: 1 },
        { name: this.$t('Billing.billing_reconciliation'), path: 'FS,billing', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_ReconciliationTab'), path: 'FS,billing,reconciliation', dataType: 2, pageType: UICustomConstants.BILLING_NATIVE_RECONCILIATION, disableCustomPage: true, enableInstruction: true, lob: 'FS' },
        { name: this.$t('CargoMsg.Cargo_Invoicing'), path: 'FS,invoice', dataType: 1 },
        { name: this.$t('SystemMaintenance.InvoiceInquiryTab'), path: 'FS,invoice,invoiceQuery', dataType: 2, pageType: UICustomConstants.INVOICE_QUERY, disableCustomPage: true, enableInstruction: true, lob: 'FS', platformInstructionCode: 'mergeInvocieFile' },
        {
          name: this.$t('CargoMsg.Cargo_WholeVehicleAndLessThanCarload'),
          path: 'IE,clBooking',
          dataType: 1,
          module: UICustomConstants.CL_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'IE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        {
          name: this.$t('SystemMaintenance.BasicTab'),
          path: 'IE,clBooking,basic',
          dataType: 2,
          pageType: UICustomConstants.INTEGRATED_CL_BOOKING
        },
        {
          name: this.$t('CargoMsg.Cargo_TruckTrailer'),
          path: 'IE,ttBooking',
          dataType: 1,
          module: UICustomConstants.TT_BOOKING_MODULE,
          enableInstruction: true,
          lob: 'IE',
          instructionFilterCallback: (p) => p.platformInstructionCode === 'sameTenantCrossDelegation'
        },
        {
          name: this.$t('SystemMaintenance.BasicTab'),
          path: 'IE,ttBooking,basic',
          dataType: 2,
          pageType: UICustomConstants.INTEGRATED_TT_BOOKING
        },
        { name: this.$t('CargoMsg.Cargo_BillTab'), path: 'FS,billing,bill', dataType: 2, pageType: UICustomConstants.BILLING_NATIVE_BILL, disableCustomPage: true, enableInstruction: true, lob: 'FS' },
        { name: this.$t('CargoMsg.Cargo_BasicPaymentRequest'), path: 'FS,billPayment', dataType: 2, pageType: UICustomConstants.BILLPAYMENT_NATIVE_MODULE, disableCustomPage: true, billPaymentSetting: true, enableBillPayment: true, lob: 'FS' },
        { name: this.$t('CargoMsg.Cargo_PendingSupervisorApproval'), path: 'FS,billPayment,pendingSupervisorApproval', dataType: 2, pageType: UICustomConstants.BILLPAYMENT_NATIVE_SUPERVISOR_APPROVAL, disableCustomPage: true, ruleSetting: true, enableBillPayment: true, lob: 'FS' },
        { name: this.$t('CargoMsg.Cargo_PendingDepartmentApproval'), path: 'FS,billPayment,pendingDepartmentApproval', dataType: 2, pageType: UICustomConstants.BILLPAYMENT_NATIVE_DEPARTMENT_APPROVAL, disableCustomPage: true, ruleSetting: true, enableBillPayment: true, lob: 'FS' },
        { name: this.$t('CargoMsg.Cargo_BasicData'), path: 'basicInfo', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_Parter'), path: 'basicInfo,SMPartner', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_CustomerVendorRating'), path: 'basicInfo,SMPartner,CustomerVendorRating', dataType: 2, pageType: UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING }
      ],
      moduleRow: null,
      validateRow: null,
      officeConfigLabel: '',
      officeList: [],
      branchId: 1,
      useHqSet: true,
      isEdit: false,
      sysBlocks: [],
      hqBlocks: null,
      branchBlocks: [],
      blocks: [],
      addedElements: [], // 新增的元素
      addedElementsForEdit: [], // 新增的元素（拷贝一份数据，用于编辑）
      deletedLanguageKeys: [], // 被删除的国际化key
      showAddedTip: false, // 是否显示新增提示
      isPreview: false,
      previewConfig: null,
      saveConfirmDialog: {
        visible: false,
        applyRange: 0
      },
      tenantInstructions: [],
      specificBusinessRules: [],
      instructionSetDialog: {
        visible: false,
        module: 0,
        pageType: 0,
        lob: '',
        availableTenantInstructions: [] // 可用的租户指令
      },
      gridTabScriptPageTypes: [
        UICustomConstants.SALES_INQUIRY_LIST,
        UICustomConstants.REMOTE_BOOKING_LIST,
        UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE,
        UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE
      ],
      gridTabScriptHideRequire: [
        UICustomConstants.SALES_INQUIRY_LIST,
        UICustomConstants.REMOTE_BOOKING_LIST
      ],
      gridTabScriptHideAlias: [
        UICustomConstants.SALES_INQUIRY_LIST,
        UICustomConstants.REMOTE_BOOKING_LIST
      ],
      gridTabScriptHideSetting: [
        UICustomConstants.SALES_INQUIRY_LIST,
        UICustomConstants.REMOTE_BOOKING_LIST
      ],
      fieldPermissionCanPageTypes: [
        UICustomConstants.SEA_BOOKING_BASIC, UICustomConstants.SEA_VERIFY_BOOKING_BASIC, UICustomConstants.SEA_BOOKING_TRUCKING, UICustomConstants.SEA_BOOKING_CUSTOMS, UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, UICustomConstants.INTEGRATED_IC_BOOKING, UICustomConstants.INTEGRATED_CL_BOOKING, UICustomConstants.INTEGRATED_TT_BOOKING, UICustomConstants.SEA_BOOKING_VESSEL, UICustomConstants.SEA_BOOKING_MBL,
        UICustomConstants.SEA_BOOKING_MBL_SPLIT, UICustomConstants.SEA_BOOKING_MBL_MERGE, UICustomConstants.SEA_BOOKING_HBL,
        UICustomConstants.SEA_BOOKING_HBL_SPLIT, UICustomConstants.SEA_BOOKING_HBL_MERGE, UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
        UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING, UICustomConstants.SEA_BOOKING_OVERSEA_BILL, UICustomConstants.AIR_VERIFY_BOOKING_BASIC, UICustomConstants.SALES_INQUIRY_LIST, UICustomConstants.REMOTE_BOOKING_LIST, UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE,
        UICustomConstants.AIR_BOOKING_BASIC, UICustomConstants.AIR_BOOKING_VESSEL, UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER
      ], // 字段权限设置可用的页面类型
      billPaymentSetDialog: {
        visible: false,
        pageType: 0,
        lob: ''
      },
      billPaymentRuleSetDialog: {
        visible: false,
        pageType: 0,
        lob: ''
      },
      enableUICustomFieldPermissioin: false,
      fieldPermissionSetDialog: {
        visible: false,
        pageType: 0,
        pageName: '',
        lob: ''
      },
      pageSetDialog: {
        visible: false,
        pageType: 0
      },
      valueSyncSetDialog: {
        visible: false,
        module: 0
      },
      billPaymentSetting: {
        uiCustomEnable: false,
        supervisorApproval: false,
        departmentApproval: false
      },
      gridTabPageTypes: [
        UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER
      ],
      seBookingWorkspaceContext: new SeBookingWorkspaceContext()
    }
  },
  computed: {
    UICustomConstants() {
      return UICustomConstants
    },
    readonly() {
      return !this.isEdit
    },
    pageSetBtnVisible() {
      return this.validateRow && [
        UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE,
        UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE,
        UICustomConstants.SEA_BOOKING_BASIC,
        UICustomConstants.SEA_BOOKING_VESSEL,
        UICustomConstants.SEA_BOOKING_MBL,
        UICustomConstants.SEA_BOOKING_HBL,
        UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
        UICustomConstants.SEA_BOOKING_TRUCKING,
        UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING,
        UICustomConstants.SEA_BOOKING_CUSTOMS,
        UICustomConstants.SEA_BOOKING_SPECIAL_GOODS,
        UICustomConstants.SEA_BOOKING_FILE_HISTORY,
        UICustomConstants.AIR_BOOKING_BASIC,
        UICustomConstants.AIR_BOOKING_VESSEL,
        UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE,
        UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE,
        UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING,
        UICustomConstants.SEA_BOOKING_OVERSEA_BILL
      ].includes(this.validateRow.pageType)
    },
    showBillPaymentRuleSettings() {
      return !this.isPreview && this.validateRow.ruleSetting && this.validateRow.pageType !== UICustomConstants.BILLPAYMENT_NATIVE_DEPARTMENT_APPROVAL
    }
  },
  created() {
    const configs = this.$store.state.settings.partnerLabelSettings
    const officeConfig = configs.find(config => config.autoKey === 'auto_office')
    this.officeConfigLabel = Object.keys(officeConfig).find(key => typeof officeConfig[key] === 'boolean' && officeConfig[key])
    this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
    // 查询租户操作指令
    queryAllTenantInstruction({}).then(res => {
      this.tenantInstructions = res.data
      for (const item of this.tenantInstructions) {
        if (item.instructionRule) {
          item.instructionRuleJson = JSON.parse(item.instructionRule)
        }
      }
    })
    // 查询特定业务规则
    querySpecificBusinessRuleByTenant({ paging: false }).then(res => {
      this.specificBusinessRules = res.data.list
    })
    this.enableUICustomFieldPermissioin = UICustomUtil.getEnableUICustomFieldPermissioin()
    this.seBookingWorkspaceContext.prepareData()
  },
  methods: {
    getOfficeLabel(item) {
      switch (this.officeConfigLabel) {
        case 'chineseName':
          return item.chineseName
        case 'englishName':
          return item.englishName
        default:
          return item.code
      }
    },
    loadData() {
      if (this.validateRow.ruleSetting) {
        this.loadBillPaymentSetting()
      }
      if (!this.validateRow || !this.validateRow.pageType || !this.branchId || this.validateRow.disableCustomPage) {
        this.sysBlocks = []
        this.hqBlocks = null
        this.branchBlocks = []
        this.blocks = []
        this.addedElements = []
        this.showAddedTip = false
        this.useHqSet = true
        return
      }
      const loading = getLoading4Cxt(this)
      getBranchElementBlockList({ pageType: this.validateRow.pageType, branchId: this.branchId }).then(res => {
        const data = res.data
        this.sysBlocks = data.sysBlocks
        this.hqBlocks = data.hqBlocks
        if (data.branchBlocks) {
          this.branchBlocks = data.branchBlocks
        } else {
          if (this.hqBlocks) {
            this.branchBlocks = lodash.cloneDeep(this.hqBlocks)
          } else {
            this.branchBlocks = lodash.cloneDeep(this.sysBlocks)
          }
          for (const block of this.branchBlocks) {
            block.useHqSet = true
            for (const element of block.uiCustomElementList) {
              element.useHqSet = true
              if (element.uiCustomFieldList) {
                for (const field of element.uiCustomFieldList) {
                  field.useHqSet = true
                }
              }
            }
          }
        }
        this.blocks = this.branchBlocks
        this.handleAddedElements()
        this.useHqSet = this.blocks.length > 0 && this.blocks[0].useHqSet
      }).finally(() => {
        loading.close()
      })
    },
    handleAddedElements() {
      const elementNameSet = new Set()
      for (const block of this.blocks) {
        for (const element of block.uiCustomElementList) {
          elementNameSet.add(element.pagePartElement.elementName)
        }
      }
      const addedElements = []
      for (const block of this.sysBlocks) {
        for (const element of block.uiCustomElementList) {
          if (!elementNameSet.has(element.pagePartElement.elementName)) {
            addedElements.push(lodash.cloneDeep(element))
          }
        }
      }
      this.addedElements = addedElements
      this.showAddedTip = false
      if (this.addedElements.length > 0) {
        const oldAddedElementNames = LocalStorageUtilsNew.getConfiguration(`addedElementNames-${this.validateRow.pageType}-${this.branchId}`)
        if (oldAddedElementNames) {
          for (const element of this.addedElements) {
            if (!oldAddedElementNames.includes(element.pagePartElement.elementName)) {
              this.showAddedTip = true
              break
            }
          }
        } else {
          this.showAddedTip = true
        }
      } else {
        LocalStorageUtilsNew.removeConfiguration(`addedElementNames-${this.validateRow.pageType}-${this.branchId}`)
      }
      this.addedElementsForEdit = this.addedElements
    },
    onEdit() {
      this.blocks = lodash.cloneDeep(this.branchBlocks)
      this.addedElementsForEdit = lodash.cloneDeep(this.addedElements)
      this.deletedLanguageKeys = []
      this.isEdit = true
      if (this.addedElements.length > 0 && this.showAddedTip) {
        const elementNames = []
        for (const element of this.addedElements) {
          elementNames.push(element.pagePartElement.elementName)
        }
        LocalStorageUtilsNew.setConfiguration(`addedElementNames-${this.validateRow.pageType}-${this.branchId}`, elementNames)
        this.showAddedTip = false
      }
    },
    onPreview() {
      const elementBlocks = []
      const elementDict = {}
      const fieldDict = {}
      for (const block of this.blocks) {
        const elementBlock = {
          title: block.customLabel || block.sysLabel,
          name: block.pagePart.pagePartName,
          elementNames: [],
          position: block.pagePartPosition,
          hide: block.hide,
          width: 0
        }
        const blockWidthSetting = UICustomUtil.getBlockWidthSetting(block)
        if (blockWidthSetting) {
          elementBlock.width = blockWidthSetting.value
        }
        for (const element of block.uiCustomElementList) {
          elementBlock.elementNames.push(element.pagePartElement.elementName)
          const fieldNames = []
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              fieldDict[field.fieldDict.fieldName] = {
                visible: field.isDisplay,
                masterVisible: field.masterIsDisplay,
                slaveVisible: field.slaveIdDisplay,
                isRequire: field.isRequire,
                label: field.customLabel || field.sysLabel
              }
              fieldNames.push(field.fieldDict.fieldName)
            }
          }
          const obj = {
            visible: element.isDisplay,
            masterVisible: element.masterIsDisplay,
            slaveVisible: element.slaveIdDisplay,
            isRequire: element.isRequire,
            label: element.customLabel || element.sysLabel,
            fieldNames
          }
          if (element.isDisplay) {
            obj.viewable = true
            obj.writable = true
          } else {
            obj.viewable = false
            obj.writable = false
          }
          obj.userCustomContent = ''
          elementDict[element.pagePartElement.elementName] = obj
        }
        elementBlocks.push(elementBlock)
      }
      if (this.gridTabPageTypes.includes(this.validateRow.pageType)) {
        this.previewConfig = {}
        for (const elementBlock of elementBlocks) {
          const partElementDict = {}
          for (const elementName of elementBlock.elementNames) {
            partElementDict[elementName] = elementDict[elementName]
          }
          this.previewConfig[elementBlock.name] = partElementDict
        }
      } else {
        this.previewConfig = {
          elementBlocks,
          elementDict,
          fieldDict,
          pageType: this.validateRow.pageType
        }
      }
      this.isPreview = true
    },
    onSave() {
      this.saveConfirmDialog.applyRange = 0
      this.saveConfirmDialog.visible = true
    },
    async doSave() {
      const loading = getLoading4Cxt(this)
      try {
        this.saveConfirmDialog.visible = false
        // 将元素的修改同步到关联字段上
        for (const block of this.blocks) {
          for (const element of block.uiCustomElementList) {
            if (element.uiCustomFieldList) {
              for (const field of element.uiCustomFieldList) {
                field.isDisplay = element.isDisplay
                field.masterIsDisplay = element.masterIsDisplay
                field.slaveIdDisplay = element.slaveIdDisplay
                field.isRequire = element.isRequire
              }
              if (element.languageList && element.uiCustomFieldList.length === 1) {
                const field = element.uiCustomFieldList[0]
                if (!field.languageList) {
                  field.languageList = []
                }
                for (const language of element.languageList) {
                  const fieldLanguage = field.languageList.find(item => item.language === language.language)
                  if (fieldLanguage) {
                    fieldLanguage.name = language.name
                  } else {
                    field.languageList.push({ type: 5, relatedUuid: field.uuid, language: language.language, name: language.name })
                  }
                }
              }
            }
          }
        }
        // 和旧版数据对比，加上是否修改标识
        this.compareAndSetDirty(this.blocks, this.branchBlocks)
        const uiCustomElementBlocks = lodash.cloneDeep(this.blocks)
        // 清空空对象，否则后端用对象接收空字符串会报错
        this.clearBlockEmptyObj(uiCustomElementBlocks)
        // 对不可设置别名的页面类型，去除不必要的语言数据
        if ([this.REMOTE_SEA_BOOKING_BASIC, this.REMOTE_RE_BOOKING_BASIC, this.REMOTE_RI_BOOKING_BASIC, this.SEA_VERIFY_BOOKING_BASIC, this.SEA_VERIFY_BOOKING_VESSEL].includes(this.validateRow.pageType)) {
          for (const block of uiCustomElementBlocks) {
            for (const element of block.uiCustomElementList) {
              delete element.languageList
              if (element.uiCustomFieldList) {
                for (const field of element.uiCustomFieldList) {
                  delete field.languageList
                }
              }
            }
          }
        }
        // 只有部分元素可设置别名的页面类型，只保留修改部分的语言数据
        else if ([this.REMOTE_AIR_BOOKING_BASIC].includes(this.validateRow.pageType)) {
          for (const block of uiCustomElementBlocks) {
            for (const element of block.uiCustomElementList) {
              if (element.languageList) {
                element.languageList = element.languageList.filter(p => p.dirty)
                if (element.languageList.length === 0) {
                  delete element.languageList
                }
              }
              if (element.uiCustomFieldList) {
                for (const field of element.uiCustomFieldList) {
                  if (field.languageList) {
                    field.languageList = field.languageList.filter(p => p.dirty)
                    if (field.languageList.length === 0) {
                      delete field.languageList
                    }
                  }
                }
              }
            }
          }
        }
        await saveUICustom({ uiCustomElementBlocks, branchId: this.branchId, applyRange: this.saveConfirmDialog.applyRange, deletedLanguageKeys: this.deletedLanguageKeys })
        loading.close()
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.isEdit = false
        this.loadData()
        this.updateGlobalUICustom(this.validateRow.pageType, this.branchId)
      } catch {
        loading.close()
      }
    },
    // 清空空对象
    clearBlockEmptyObj(blocks) {
      for (const block of blocks) {
        const pagePart = block.pagePart
        if (!pagePart.languageList) {
          delete pagePart.languageList
        }
        for (const pagePartElement of pagePart.pagePartElementList) {
          if (!pagePartElement.languageList) {
            delete pagePartElement.languageList
          }
          if (!pagePartElement.fieldDictList) {
            delete pagePartElement.fieldDictList
          }
        }
        if (!block.languageList) {
          delete block.languageList
        }
        for (const element of block.uiCustomElementList) {
          const pagePartElement = element.pagePartElement
          if (!pagePartElement.languageList) {
            delete pagePartElement.languageList
          }
          if (!pagePartElement.fieldDictList) {
            delete pagePartElement.fieldDictList
          }
          if (!element.languageList) {
            delete element.languageList
          }
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              if (!field.languageList) {
                delete field.languageList
              }
            }
          } else {
            delete element.uiCustomFieldList
          }
          if (!element.uiCustomElementFilterList) {
            delete element.uiCustomElementFilterList
          }
          if (element.hqUICustomElement) {
            const hqElement = element.hqUICustomElement
            const pagePartElement = hqElement.pagePartElement
            if (!pagePartElement.languageList) {
              delete pagePartElement.languageList
            }
            if (!pagePartElement.fieldDictList) {
              delete pagePartElement.fieldDictList
            }
            if (!hqElement.languageList) {
              delete hqElement.languageList
            }
            if (hqElement.uiCustomFieldList) {
              for (const field of hqElement.uiCustomFieldList) {
                if (!field.languageList) {
                  delete field.languageList
                }
              }
            } else {
              delete hqElement.uiCustomFieldList
            }
            if (!hqElement.uiCustomElementFilterList) {
              delete hqElement.uiCustomElementFilterList
            }
            delete hqElement.hqUICustomElement
          } else {
            delete element.hqUICustomElement
          }
        }
      }
    },
    compareAndSetDirty(newData, oldData) {
      if (newData instanceof Array) {
        for (const newItem of newData) {
          const oldItem = newItem.uuid && oldData ? oldData.find(p => p.uuid === newItem.uuid) || {} : {}
          this.compareAndSetDirty(newItem, oldItem)
        }
      } else if (newData instanceof Object) {
        if (!newData.uuid) {
          newData.dirty = true
        }
        for (const key in newData) {
          if (newData[key] instanceof Array) {
            this.compareAndSetDirty(newData[key], oldData[key] || [])
            continue
          }
          if (newData[key] instanceof Object) {
            this.compareAndSetDirty(newData[key], oldData[key] || {})
            continue
          }
          if (newData[key] !== oldData[key]) {
            newData.dirty = true
          }
        }
      }
    },
    updateGlobalUICustom(pageType, branchId) {
      if (!pageType) {
        return
      }
      if (this.$store.state.uiCustom.enable) {
        this.$store.dispatch('uiCustom/updateUICustomPageInfo', { pageType, branchIds: branchId === 1 ? Array.from(this.officeList, p => p.officeId) : [branchId] })
      }
    },
    onCancel() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.blocks = this.branchBlocks
        this.addedElementsForEdit = this.addedElements
        this.isEdit = false
      }).catch(() => { })
    },
    onReset() {
      this.$confirm(this.$t('SystemMaintenance.ResetCustomSetConfirm'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.coverBlocks(this.blocks, this.sysBlocks)
        this.addedElementsForEdit = []
      }).catch(() => { })
    },
    // 覆盖blocks数据
    coverBlocks(blocks, newBlocks) {
      newBlocks = lodash.cloneDeep(newBlocks) // 拷贝一份，避免影响原数据
      const blockMap = new Map()
      const elementMap = new Map()
      const fieldMap = new Map()
      for (const block of blocks) {
        blockMap.set(block.pagePartUuid, block)
        for (const element of block.uiCustomElementList) {
          elementMap.set(element.pagePartElementUuid, element)
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              fieldMap.set(field.fieldDictUuid, field)
            }
          }
        }
      }
      for (const newBlock of newBlocks) {
        const block = blockMap.get(newBlock.pagePartUuid)
        if (block) {
          newBlock.uuid = block.uuid
          newBlock.version = block.version
          newBlock.tenantId = block.tenantId
          newBlock.useHqSet = block.useHqSet
          if (block.languageList) {
            newBlock.languageList = this.converLanguages(block.languageList, newBlock.languageList)
          }
        }
        newBlock.dirty = true
        for (const newElement of newBlock.uiCustomElementList) {
          newElement.uiCustomElementBlockUuid = newBlock.uuid
          const element = elementMap.get(newElement.pagePartElementUuid)
          if (element) {
            newElement.uuid = element.uuid
            newElement.version = element.version
            newElement.tenantId = element.tenantId
            newElement.useHqSet = element.useHqSet
            if (element.languageList) {
              newElement.languageList = this.converLanguages(element.languageList, newElement.languageList)
            }
          }
          newElement.dirty = true
          if (newElement.uiCustomFieldList) {
            for (const newField of newElement.uiCustomFieldList) {
              const field = fieldMap.get(newField.fieldDictUuid)
              if (field) {
                newField.uuid = field.uuid
                newField.version = field.version
                newField.tenantId = field.tenantId
                newField.useHqSet = field.useHqSet
                if (field.languageList) {
                  newField.languageList = this.converLanguages(field.languageList, newField.languageList)
                }
              }
              newField.dirty = true
            }
          }
        }
      }
      blocks.splice(0, blocks.length, ...newBlocks)
      return blocks
    },
    // 覆盖旧语言
    converLanguages(oldLaguages, newLaguages) {
      if (newLaguages && newLaguages.length > 0) {
        for (const oldLaguage of oldLaguages) {
          oldLaguage.name = ''
        }
        for (const newLaguage of newLaguages) {
          const oldLaguage = oldLaguages.find(p => p.language === newLaguage.language)
          if (oldLaguage) {
            oldLaguage.name = newLaguage.name
            oldLaguage.dirty = true
          } else {
            oldLaguages.push(newLaguage)
            newLaguage.dirty = true
          }
        }
        return oldLaguages
      } else {
        for (const oldLaguage of oldLaguages) {
          if (oldLaguage.uuid && !this.deletedLanguageKeys.includes(oldLaguage.uuid)) {
            this.deletedLanguageKeys.push(oldLaguage.uuid)
          }
        }
        return []
      }
    },
    onUseHqSetInput(val) {
      const uiCustomElementBlocks = lodash.cloneDeep(this.blocks)
      this.deletedLanguageKeys = []
      for (const block of uiCustomElementBlocks) {
        block.useHqSet = val
        block.dirty = true
        for (const element of block.uiCustomElementList) {
          element.useHqSet = val
          element.dirty = true
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              field.useHqSet = val
              field.dirty = true
            }
          }
        }
      }
      if (val) {
        this.$confirm(this.$t('SystemMaintenance.ApplyHQSetting'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('Message.Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const data = { branchId: this.branchId }
          if (this.branchId === 1) {
            data.uiCustomElementBlocks = uiCustomElementBlocks
            data.applyRange = 1
          } else {
            data.uiCustomElementBlocks = this.coverBlocks(uiCustomElementBlocks, this.hqBlocks || this.sysBlocks)
          }
          data.deletedLanguageKeys = this.deletedLanguageKeys
          // 删除空对象，否则后端用对象接收空字符串会报错
          this.clearBlockEmptyObj(uiCustomElementBlocks)
          const loading = getLoading4Cxt(this)
          saveUICustom(data).then(res => {
            loading.close()
            this.$message.success(this.$t('Message.SaveSuccessfully'))
            this.loadData()
            this.updateGlobalUICustom(this.validateRow.pageType, this.branchId)
          }).catch(() => {
            loading.close()
          })
        }).catch(() => { })
      } else {
        // 删除空对象，否则后端用对象接收空字符串会报错
        this.clearBlockEmptyObj(uiCustomElementBlocks)
        const loading = getLoading4Cxt(this)
        saveUICustom({ uiCustomElementBlocks, branchId: this.branchId }).then(res => {
          loading.close()
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.loadData()
          this.updateGlobalUICustom(this.validateRow.pageType, this.branchId)
        }).catch(() => {
          loading.close()
        })
      }
    },
    editOpInstructionDialog() {
      const row = {}
      if (this.moduleRow) {
        row.module = this.moduleRow.module
        row.pageType = 0
        row.lob = this.moduleRow.lob
        row.platformInstructionCode = this.moduleRow.platformInstructionCode
        row.instructionType = this.moduleRow.instructionType
        row.instructionRule = this.moduleRow.instructionRule
        row.instructionFilterCallback = this.moduleRow.instructionFilterCallback
      } else {
        row.module = 0
        row.pageType = this.validateRow.pageType
        row.lob = this.validateRow.lob
        row.platformInstructionCode = this.validateRow.platformInstructionCode
        row.instructionType = this.validateRow.instructionType
        row.instructionRule = this.validateRow.instructionRule
        row.instructionFilterCallback = this.validateRow.instructionFilterCallback
      }
      this.instructionSetDialog.visible = true
      this.instructionSetDialog.module = row.module
      this.instructionSetDialog.pageType = row.pageType
      this.instructionSetDialog.lob = row.lob || ''
      if (row.instructionFilterCallback) {
        this.instructionSetDialog.availableTenantInstructions = this.tenantInstructions.filter(row.instructionFilterCallback)
      } else if (row.platformInstructionCode) {
        this.instructionSetDialog.availableTenantInstructions = this.tenantInstructions.filter(p => p.platformInstructionCode === row.platformInstructionCode)
      } else if (row.instructionType) {
        this.instructionSetDialog.availableTenantInstructions = this.tenantInstructions.filter(p => {
          if (p.instructionType !== row.instructionType) {
            return false
          }
          if (row.instructionRule && Object.keys(row.instructionRule).length > 0) {
            if (p.instructionRuleJson && Object.keys(p.instructionRuleJson).length > 0) {
              for (const key in row.instructionRule) {
                if (row.instructionRule[key] !== p.instructionRuleJson[key]) {
                  return false
                }
              }
              return true
            }
            return false
          }
          return true
        })
      } else {
        this.instructionSetDialog.availableTenantInstructions = this.tenantInstructions
      }
    },
    billPaymentSettingsHandler() {
      this.billPaymentSetDialog.visible = true
      this.billPaymentSetDialog.pageType = this.validateRow.pageType
      this.billPaymentSetDialog.lob = this.validateRow.lob || ''
    },
    billPaymentRuleSettingsHandler() {
      // 部门本次不支持规则设置
      if (this.validateRow.pageType === UICustomConstants.BILLPAYMENT_NATIVE_DEPARTMENT_APPROVAL) {
        return
      }
      this.billPaymentRuleSetDialog.visible = true
      this.billPaymentRuleSetDialog.pageType = this.validateRow.pageType
      this.billPaymentRuleSetDialog.lob = this.validateRow.lob || ''
    },
    onFieldPermissionSet() {
      this.fieldPermissionSetDialog.visible = true
      this.fieldPermissionSetDialog.pageType = this.validateRow.pageType
      this.fieldPermissionSetDialog.pageName = this.validateRow.name
      if (this.validateRow.path === 'IE,icBooking,basic') {
        this.fieldPermissionSetDialog.lob = 'IC'
      } else if (this.validateRow.path === 'IE,clBooking,basic') {
        this.fieldPermissionSetDialog.lob = 'CL'
      } else if (this.validateRow.path === 'IE,ttBooking,basic') {
        this.fieldPermissionSetDialog.lob = 'TT'
      } else {
        this.fieldPermissionSetDialog.lob = this.validateRow.path.split(',')[0]
      }
    },
    onFieldPermissionSetUpdateCallback() {
      this.updateGlobalUICustom(this.validateRow.pageType, this.branchId)
    },
    showPageSetDialog() {
      this.pageSetDialog.visible = true
      this.pageSetDialog.pageType = this.validateRow.pageType
    },
    showValueSyncSetDialog() {
      this.valueSyncSetDialog.visible = true
      this.valueSyncSetDialog.module = this.moduleRow.module
    },
    async loadBillPaymentSetting() {
      const response = await getBranchBillPaymentSetting({
        pageType: UICustomConstants.BILLPAYMENT_NATIVE_MODULE,
        branchId: this.branchId
      }).then(res => res.data)
      if (response) {
        this.billPaymentSetting.uiCustomEnable = response.openUiCustom
        this.billPaymentSetting.supervisorApproval = response.supervisorApproval
        this.billPaymentSetting.departmentApproval = response.departmentApproval
      }
    },
    canSetAliasFunction(pageType, element) {
      if (pageType === UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER) {
        if (['userDefinedField1', 'userDefinedField2', 'userDefinedField3', 'userDefinedField4', 'userDefinedField1/2', 'userDefinedField2/2', 'userDefinedField3/2', 'userDefinedField4/2'].includes(element.pagePartElement.elementName)) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
  .not-click {
    pointer-events: none;
  }
</style>
